import React, { useContext,useState } from 'react';
import { ThemeContext } from 'providers/ThemeProvider';
import { Container } from 'components/common';
import { Wrapper, Grid, Filter} from './styles';
import { Project } from './Project';
import {FaReact,FaNode} from 'react-icons/fa'
import {DiMongodb,DiAndroid} from 'react-icons/di'
import {SiMaterialUi,SiFirebase,SiKotlin,SiDart,SiFlutter} from 'react-icons/si'

export const Projects = () => {
  const { theme } = useContext(ThemeContext);

  const [selected, setSelected] = useState("WebApps")
  
  return (
    <Wrapper as={Container} id="projects">
      <h2>Projects</h2>
      <Filter theme={theme}>
        <p style={{ color: selected === "WebApps" && "#6c63ff"}} onClick={()=>setSelected('WebApps')}>Web Apps</p>  
        <p style={{ color: selected === "MobileApp" && "#6c63ff"}} onClick={()=>setSelected('MobileApp')}>Mobile Apps</p>
      </Filter>
      <Grid>
      {
        selected === "MobileApp" && <>
        <Project 
        key="item7" 
        title="Planner & Keeper (React Native)" 
        repoURL ="https://github.com/akshayjadhav4/planner-and-resource-keeper"  
        description="React native app for tracking project progress and keeping resources(docs, blog) referenced for learning or solving problems."
        techStack={[FaReact,SiFirebase]}
        />
        <Project 
        key="item8" 
        title="News App (Kotlin)" 
        repoURL ="https://github.com/akshayjadhav4/News-App-Kotlin"  
        description="News app with retrofit , kotlin coroutine , room database. In this app user can browse news, save news locally and also can search with topic keywords."
        techStack={[DiAndroid,SiKotlin]}
        />

        <Project 
        key="item9" 
        title="Workout App (Flutter)" 
        repoURL ="https://github.com/akshayjadhav4/Workout-App-"  
        description="This app suggest five workouts each time you open app.User can set Reps as per need and start workout. All workout information also provided to guide user."
        techStack={[SiDart,SiFlutter]}
        />

        <Project 
        key="item10" 
        title="Contacts (Flutter)" 
        repoURL ="https://github.com/akshayjadhav4/Contact-App"  
        description="In this app contacts are saved on firebase realtime database. User can access saved contacts by just Signing In to their account.For saving a images firebase storage is used. Images featched using Network image function of flutter."
        techStack={[SiDart,SiFlutter,SiFirebase]}
        />

        <Project 
        key="item11" 
        title="Twitter Mobile (Flutter)" 
        repoURL ="https://github.com/akshayjadhav4/Twitter"  
        description="User can create account,login , tweet ,likes others tweet and delete own tweets."
        techStack={[SiDart,SiFlutter,SiFirebase]}
        />
        </>
      }
       {
        selected === "WebApps" && <>
        <Project 
        key="item1" 
        title="Instagram Clone (MERN)" 
        repoURL ="https://github.com/akshayjadhav4/instagram-frontend-mern"  
        description="This clone has all features of Instagram like login, registration, add a post, like a post, comment, follow, unfollow, and real-time messaging like Instagram."
        liveDemoURL="https://instagramclonemern.netlify.app/"
        techStack={[FaReact,FaNode,DiMongodb,SiMaterialUi]}
        />

        <Project 
        key="item2" 
        title="My Store (MERN)" 
        repoURL ="https://github.com/akshayjadhav4/E-Commerce-frontend"  
        description=" This e-Commerce site has an admin panel where the admin can manage categories, products, orders all stuff. Also, users can add products to cart, check orders, add reviews and star ratings to purchased products. And the Braintree payment gateway is used for processing payments. "
        liveDemoURL="https://my-ecommstore.netlify.app/"
        techStack={[FaReact,FaNode,DiMongodb,SiMaterialUi]}
        />

        
        <Project 
        key="item3" 
        title="COVID-19 Tracker" 
        repoURL ="https://github.com/akshayjadhav4/COVID-TRACKER"  
        description="This shows all country's covid stats like active cases, deaths, recovered. also, it has a line graph to show the coronavirus outbreak trend over time. and also has a pie chart. It also has a tabular representation of data."
        liveDemoURL="https://covid-19-tracker-reactapp.netlify.app/"
        techStack={[FaReact,SiMaterialUi]}
        />

        <Project 
        key="item4" 
        title="Cookz Recipe" 
        repoURL ="https://github.com/akshayjadhav4/recipe-app-react"  
        description="In this app, users can search for recipes. also existing categories like breakfast, lunch, dinner, time based also given so that users can directly view recipes based on that.App also has filters so that the user can search recipes easily. For all recipes, the user has access to all ingredients, nutrients percentage, recipe, etc. "
        liveDemoURL="https://cookzrecipe.netlify.app/"
        techStack={[FaReact,SiMaterialUi]}
        />

        <Project 
        key="item5" 
        title="Twitter Clone" 
        repoURL ="https://github.com/akshayjadhav4/twitter-clone-react-firebase"  
        description="Basic functionality user can create account,login , tweet ,likes others tweet and delete own tweets.Firebase authentication and Firestore database used."
        liveDemoURL="https://react-twitter-clone-d6316.web.app/login"
        techStack={[FaReact,SiFirebase,SiMaterialUi]}
        />

        <Project 
        key="item6" 
        title="Group Messenger" 
        repoURL ="https://github.com/akshayjadhav4/Group-chat-mern-frontend"  
        description="WhatsApp like group chat application. It has Google sign in for authentication.User can create group and other users can join that groups. It has realtime messaging feature."
        liveDemoURL="https://whats-app-mern-clone.web.app/"
        techStack={[FaReact,FaNode,DiMongodb,SiFirebase,SiMaterialUi]}
        />
        
        </>
      }


      </Grid>
    </Wrapper>
  );
};